import { useCallback } from 'react';
import { BlogLangType } from '../../types/blogTypes';
import { useBlogContext } from '../blogViews/BlogProvider';

const blogResource = {
    blogIndexTitle: {
        ko: '40대에 은퇴하기',
        en: 'Retire in 40s',
        ja: '40代で退職する',
        de: '40er aussteigen',
        fr: 'Retraite à 40 ans',
        es: 'Retirarse a los 40 años',
        it: 'Ritiro a 40 anni',
        nl: '40 jaar uitstappen',
        pt: 'Aposentar aos 40 anos',
    },
    blogIntroTitle: {
        ko: '40대 은퇴를 꿈꾸는 사람들이 함께 만들어가는 이야기',
        en: 'A blog by a team working toward early retirement in our 40s',
        ja: '40代でのリタイアを目指して歩む、小さなチームの記録',
        de: 'Ein Blog von einem kleinen Team, das sich auf die frühe Rente in unseren 40ern stellt',
        fr: 'Un blog par un petit équipe qui travaille vers la retraite à 40 ans',
        es: 'Un blog de un pequeño equipo que trabaja hacia la jubilación a los 40 años',
        it: 'Un blog di un piccolo team che lavora per la pensione a 40 anni',
        nl: 'Een blog van een klein team dat werkt naar de pensionering op 40 jaar',
        pt: 'Um blog de um pequeno time que trabalha para a aposentadoria aos 40 anos',
    },
    blogIntroDesc: {
        ko: '우리는 40대에 은퇴하는 것을 목표로 함께 공부하고 투자하는 작은 팀입니다.\n\n미국 주식에 투자하고, 경제와 사회에 대해 꾸준히 배우며, 조금씩 경제적 자유를 준비하고 있어요.\n\n은퇴 이후의 삶도 소중하게 생각하며, 미술·음악·역사 같은 다양한 관심사를 함께 나누고 있습니다.\n\n\n이 블로그는 우리가 함께 배우고 성장해 나가는 과정을 담은 기록입니다.\n\n비슷한 길을 걷고 있는 분들에게 작은 응원이 되길 바랍니다.',
        en: "We're a small team with a shared goal: to retire in our 40s.\n\nWe invest in U.S. stocks, learn about the economy and society, and prepare step by step for financial independence.\n\nWe also value what comes after retirement—spending time on art, music, history, and other interests that enrich life.\n\n\nThis blog is a record of our learning and growth as a team.\n\nWe hope it offers insight and encouragement to those on a similar path.",
        ja: '私たちは、40代でのリタイアを目指して、一緒に学び投資に取り組んでいる小さなチームです。\n\nアメリカ株に投資しながら、経済や社会について少しずつ学び、経済的な自由を目指しています。\n\nまた、リタイア後の人生も大切に考え、アートや音楽、歴史など、日々の豊かさにつながる関心も共有しています。\n\n\nこのブログは、そんな私たちの学びと成長の記録です。\n\n同じ目標を持つ方にとって、少しでもヒントや励ましになれば嬉しいです。',
        de: 'Wir sind ein kleines Team, das sich auf die frühe Rente in unseren 40ern stellt.\n\nWir investieren in US-Aktien, lernen über die Wirtschaft und Gesellschaft und bereiten uns Schritt für Schritt auf finanzielle Unabhängigkeit vor.\n\nWir achten auch auf das Leben nach der Rente – wir verbringen Zeit mit Kunst, Musik, Geschichte und anderen Interessen, die unseren Lebensstil bereichern.\n\n\nDieser Blog ist ein Protokoll unserer Lern- und Wachstumsprozesse als Team.\n\nWir hoffen, dass er für Menschen, die auf ähnlichen Wegen gehen, einen kleinen Anstoß bietet.',
        fr: "Nous sommes un petit équipe qui travaille vers la retraite à 40 ans.\n\nNous investissons dans les actions américaines, nous apprenons à propos de l'économie et de la société, et nous préparons pas à pas pour l'indépendance financière.\n\nNous valorisons également la vie après la retraite – nous passons du temps sur l'art, la musique, l'histoire et d'autres intérêts qui enrichissent notre vie.\n\n\nCe blog est un journal de nos apprentissages et de nos progrès en tant que team.\n\nNous espérons que cela offre un peu de conseils et de soutien à ceux qui suivent un chemin similaire.",
        es: 'Somos un pequeño equipo que trabaja hacia la jubilación a los 40 años.\n\nInvertimos en acciones estadounidenses, aprendemos sobre la economía y la sociedad, y nos preparamos paso a paso para la independencia financiera.\n\nTambién valoramos la vida después de la jubilación – pasamos tiempo en arte, música, historia y otros intereses que enriquecen nuestra vida.\n\n\nEste blog es un registro de nuestros aprendizajes y crecimiento como equipo.\n\nEsperamos que ofrezca un poco de orientación y apoyo a quienes siguen un camino similar.',
        it: "Siamo un piccolo team che lavora per la pensione a 40 anni.\n\nInvestiamo in azioni americane, impariamo sull'economia e la società, e ci prepariamo passo passo per l'indipendenza finanziaria.\n\nValutiamo anche la vita dopo la pensione – passiamo tempo su arte, musica, storia e altri interessi che arricchiscono la nostra vita.\n\n\nQuesto blog è un registro dei nostri apprendimenti e del nostro crescita come team.\n\nSperiamo che offra un po' di orientamento e sostegno a chi segue un percorso simile.",
        nl: 'We zijn een klein team dat werkt naar de pensionering op 40 jaar.\n\nWe investeren in Amerikaanse aandelen, leren over de economie en de samenleving, en bereiden ons stap voor stap voor financiële onafhankelijkheid.\n\nWe waarden ook het leven na de pensionering – we brengen tijd door met kunst, muziek, geschiedenis en andere interesses die onze levensstijl verrijken.\n\n\nDeze blog is een registratie van onze leer- en groeiprocessen als team.\n\nWe hopen dat het een beetje richting en steun biedt aan degenen die op een vergelijkbare weg gaan.',
        pt: 'Somos um pequeno time que trabalha para a aposentadoria aos 40 anos.\n\nInvestimos em ações americanas, aprendemos sobre a economia e a sociedade, e nos preparamos passo a passo para a independência financeira.\n\nTambém valorizamos a vida após a aposentadoria – passamos tempo em arte, música, história e outros interesses que enriquecem nossa vida.\n\n\nEste blog é um registro de nossos aprendizados e crescimento como time.\n\nEsperamos que ofereça um pouco de orientação e apoio a quem segue um caminho semelhante.',
    },
    goToBlog: {
        ko: '블로그 보러 가기',
        en: 'Go to Blog',
        ja: 'ブログを見る',
        de: 'Zur Blog',
        fr: 'Aller au blog',
        es: 'Ir al blog',
        it: 'Vai al blog',
        nl: 'Ga naar blog',
        pt: 'Ir para o blog',
    },
    home: {
        ko: '홈',
        en: 'Home',
        ja: 'ホーム',
        de: 'Startseite',
        fr: 'Accueil',
        es: 'Inicio',
        it: 'Home',
        nl: 'Startpagina',
        pt: 'Início',
    },
    category: {
        ko: '카테고리',
        en: 'Category',
        ja: 'カテゴリ',
        de: 'Kategorie',
        fr: 'Catégorie',
        es: 'Categoría',
        it: 'Categoria',
        nl: 'Categorie',
        pt: 'Categoria',
    },
    more: {
        ko: '더보기',
        en: 'More',
        ja: 'もっと見る',
        de: 'Mehr',
        fr: 'Plus',
        es: 'Más',
        it: 'Più',
        nl: 'Meer',
        pt: 'Mais',
    },
    tickers: {
        ko: '관련 종목',
        en: 'Related Tickers',
        ja: '関連銘柄',
        de: 'Verwandte Aktien',
        fr: 'Actions associées',
        es: 'Acciones relacionadas',
        it: 'Azioni correlate',
        nl: 'Gerelateerde aandelen',
        pt: 'Ações relacionadas',
    },
    langName: {
        ko: '한국어',
        en: 'English',
        ja: '日本語',
        de: 'Deutsch',
        fr: 'Français',
        es: 'Español',
        it: 'Italiano',
        nl: 'Nederlands',
        pt: 'Português',
    },
    terms: {
        ko: '이용약관',
        en: 'Terms of Service',
        ja: '利用規約',
        de: 'Nutzungsbedingungen',
        fr: "Conditions d'utilisation",
        es: 'Términos de servicio',
        it: 'Condizioni di utilizzo',
        nl: 'Gebruiksvoorwaarden',
        pt: 'Termos de uso',
    },
    privacy: {
        ko: '개인정보 처리방침',
        en: 'Privacy Policy',
        ja: 'プライバシーポリシー',
        de: 'Datenschutzerklärung',
        fr: 'Politique de confidentialité',
        es: 'Política de privacidad',
        it: 'Informativa sulla privacy',
        nl: 'Privacyverklaring',
        pt: 'Política de privacidade',
    },
    // 카테고리별 이름
    'economic-news': {
        ko: '경제 뉴스',
        en: 'Economic News',
        ja: '経済ニュース',
        de: 'Wirtschaftsnews',
        fr: 'Actualités économiques',
        es: 'Noticias económicas',
        it: 'Notizie economiche',
        nl: 'Economische nieuws',
        pt: 'Notícias econômicas',
    },
    'classical-music': {
        ko: '클래식 음악',
        en: 'Classical Music',
        ja: 'クラシック音楽',
        de: 'Klassische Musik',
        fr: 'Musique classique',
        es: 'Música clásica',
        it: 'Musica classica',
        nl: 'Classieke muziek',
        pt: 'Música clássica',
    },
} as const;

/**
 * 블로그 용어 번역
 * - 훅이 없을 때 사용
 */
export const getBlogTrans = (key: keyof typeof blogResource, lang: BlogLangType) => {
    return blogResource[key]?.[lang] || key;
};

/**
 * 블로그 용어 번역 훅
 */
export const useBlogTrans = () => {
    const { lang } = useBlogContext();

    const trans = useCallback(
        (key: keyof typeof blogResource) => {
            return blogResource[key]?.[lang!] || key;
        },
        [lang],
    );

    return { trans };
};
